import { c as _c } from "react/compiler-runtime";
import { useGSAP } from '@gsap/react';
import { RefObject } from 'react';
import { gsap } from '@/lib/gsap';
interface Params {
  wrapperRef: RefObject<HTMLDivElement | null>;
  flashRef: RefObject<HTMLImageElement | null>;
  isPageReady: boolean;
  flashMountKey: number;
}
export function useHeroFlashIntro(t0) {
  const $ = _c(9);
  const {
    wrapperRef,
    flashRef,
    isPageReady,
    flashMountKey
  } = t0;
  let t1;
  if ($[0] !== flashRef || $[1] !== isPageReady) {
    t1 = () => {
      if (!isPageReady) {
        return;
      }
      const flash = flashRef.current;
      if (!flash) {
        return;
      }
      const matchMedia = gsap.matchMedia();
      matchMedia.add({
        isDesktop: "(min-width: 992px)",
        isMobile: "(max-width: 991px)"
      }, context => {
        const {
          isMobile
        } = context.conditions as gsap.Conditions;
        if (isMobile) {
          gsap.set(flash, {
            xPercent: -50,
            yPercent: -50
          });
        }
        gsap.to(flash, {
          scale: isMobile ? 1.5 : 1.05,
          force3D: !isMobile,
          duration: 1.2,
          delay: 0.35,
          ease: "power3.out"
        });
      });
    };
    $[0] = flashRef;
    $[1] = isPageReady;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== flashMountKey || $[4] !== isPageReady) {
    t2 = [isPageReady, flashMountKey];
    $[3] = flashMountKey;
    $[4] = isPageReady;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2 || $[7] !== wrapperRef) {
    t3 = {
      scope: wrapperRef,
      dependencies: t2
    };
    $[6] = t2;
    $[7] = wrapperRef;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useGSAP(t1, t3);
}